import { VariantProps, CSS } from '@stitches/react';

import styled from '@/styles';
import colors from '@/styles/colors';

const Wrapper = styled('span', {
  $$bgColor: '$colors$neutralA12',
  $$color: '$colors$textDefault',

  padding: '4px 8px',

  backgroundColor: '$$bgColor',
  borderRadius: '$round',
  color: '$$color',

  fontSize: '$sm',
  whiteSpace: 'nowrap',

  variants: {
    size: {
      sm: {},
      md: {
        fontSize: '$md',
      },
      lg: {
        fontSize: '$lg',
      },
    },
    status: {
      neutral: {
        '@phoneOnly': {
          $$bgColor: colors.badgeBrown,
          $$color: '$colors$whiteA96',
        },
      },
      theme: {
        $$bgColor: '$colors$themeA16',
        $$color: '$colors$themeDarker',
        '@phoneOnly': {
          $$bgColor: '$colors$successTick',
          $$color: '$colors$whiteA96',
        },
      },
      themeDefault: {
        $$color: 'white',
        $$bgColor: '$colors$themeDefault',
      },
      warning: {
        $$bgColor: '$colors$warningA32',
        $$color: '$colors$textDefault',
        '@phoneOnly': {
          $$bgColor: colors.badgeGreen,
          $$color: '$colors$whiteA96',
        },
      },
      danger: {
        $$bgColor: '$colors$dangerA12',
        $$color: '$colors$dangerDarker',
      },
      success: {
        $$bgColor: '$colors$neuralLessDark',
        $$color: '$colors$textLighter',
        '@phoneOnly': {
          $$bgColor: colors.badgelBlue,
          $$color: '$colors$whiteA96',
        },
      },
      successGreen: {
        $$bgColor: '#DAF9D7',
        $$color: '#106F00',
      },
      disabled: {
        $$bgColor: '$colors$neutralA12',
        $$color: '$colors$textLightest',
      },
      // GRAVY-10404: a suspended/permanently-removed worker's dependability
      // badge — a dark "blocked" chip, distinct from `danger` (Monitored) and
      // the warning/caution badges. Matches the card's Suspended tier pill.
      suspended: {
        $$bgColor: colors.depSuspended,
        $$color: colors.whiteA96,
      },
    },
  },

  defaultVariants: {
    size: 'sm',
    status: 'neutral',
  },
});

type Props = VariantProps<typeof Wrapper> & {
  label: string;
  css?: CSS;
};

const Badge = ({ label, ...props }: Props) => {
  return <Wrapper {...props}>{label}</Wrapper>;
};

export default Badge;
